export enum EmbedActionTypes {
  VIEWER_FEEDBACK = 'VIEWER_FEEDBACK',
  CHANNEL_VIEWER_FEEDBACK = 'CHANNEL_VIEWER_FEEDBACK',
}
